import * as React from 'react';
import { Loader } from 'Src/components/Loader/Loader';
import {
  getSuperAdminRegistrationSettings,
  updateSuperAdminRegistrationSettings
} from 'Src/helpers/service/superadmin/registrationSettings';

interface State {
  isLoading: boolean;
  isSaving: boolean;
  domainsText: string;
  errorMessage: string;
  successMessage: string;
}

function normalizeDomains(text: string): string[] {
  const seen: Record<string, boolean> = {};
  const domains: string[] = [];

  text
    .split(/\r?\n|,/)
    .map(item => item.trim().toLowerCase().replace(/^@+/, ''))
    .filter(Boolean)
    .forEach(domain => {
      if (seen[domain]) return;
      seen[domain] = true;
      domains.push(domain);
    });

  return domains;
}

export class SuperAdminRegistrationDomains extends React.Component<{}, State> {
  constructor(props: {}) {
    super(props);
    this.state = {
      isLoading: false,
      isSaving: false,
      domainsText: '',
      errorMessage: '',
      successMessage: ''
    };
  }

  componentDidMount() {
    this.load();
  }

  load = () => {
    this.setState({ isLoading: true, errorMessage: '', successMessage: '' });

    getSuperAdminRegistrationSettings()
      .then(settings => {
        this.setState({
          isLoading: false,
          domainsText: (settings.phoneOptionalEmailDomains || []).join('\n')
        });
      })
      .catch(() => this.setState({ isLoading: false, errorMessage: 'Could not load registration domains.' }));
  };

  onSave = () => {
    const phoneOptionalEmailDomains = normalizeDomains(this.state.domainsText);

    this.setState({ isSaving: true, errorMessage: '', successMessage: '' });

    updateSuperAdminRegistrationSettings({ phoneOptionalEmailDomains })
      .then(settings => {
        this.setState({
          isSaving: false,
          domainsText: (settings.phoneOptionalEmailDomains || []).join('\n'),
          successMessage: 'Registration domains saved.'
        });
      })
      .catch(() => this.setState({ isSaving: false, errorMessage: 'Could not save registration domains.' }));
  };

  render() {
    const { isLoading, isSaving, domainsText, errorMessage, successMessage } = this.state;

    if (isLoading) return <Loader />;

    return (
      <div>
        <div className="mb-3">
          <h4 className="mb-1">Registration domains</h4>
          <div className="text-muted small">
            Users with these email domains can register without a phone number or SMS verification.
          </div>
        </div>

        {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
        {successMessage && <div className="alert alert-success">{successMessage}</div>}

        <div className="form-group">
          <label className="small font-weight-bold">Phone-optional email domains</label>
          <textarea
            className="form-control"
            rows={10}
            value={domainsText}
            onChange={e => this.setState({ domainsText: e.target.value, successMessage: '' })}
            disabled={isSaving}
            placeholder="squadintouch.com"
          />
          <small className="form-text text-muted">Enter one domain per line. Leading @ is optional.</small>
        </div>

        <button className="btn btn-primary btn-sm" onClick={this.onSave} disabled={isSaving}>
          {isSaving ? 'Saving...' : 'Save'}
        </button>
      </div>
    );
  }
}
